import styled from "styled-components";
import InLineButton from "../elements/InLineEditButtonStyled";

const InLineEditButtonCancelStyled = styled(InLineButton)`
  background-color: ${(props) => props.theme.cancelbuttonbackgroundcolor};
  padding-bottom: 5px;
`;

export default InLineEditButtonCancelStyled;
